import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { currentUserSelector } from "../store/current_user"
import { hasPageAccessPermission } from 'utils/pageAccessPermissionChecker'

export function usePageAccessRestriction() {
  const currentUser = useSelector(currentUserSelector)
  const location = useLocation();
  const history = useHistory();
  
  useEffect(() => {
    if (!currentUser) return;
    const path = location.pathname.replace(/\/+$/, '');
    if (
      !hasPageAccessPermission({
        path,
        groups: currentUser?.groupName ?? []
      })
    ) {
      history.push("/")
    }
  }, [location, currentUser, history]);
}